import React from "react";
import { Slider as CoreSlider } from "@jelly/ui";

import defaultStyle from "./Slider.audio.module.scss";

export const Slider: React.FC<React.ComponentProps<typeof CoreSlider>> = (props) => {
  return <CoreSlider {...props} style={defaultStyle} />;
};
